export const taxLiabilityReviewPtBr = {
  title: 'Revisar passivo tributário',
  history: 'Há valores anteriores que precisam de revisão contábil.',
  request: 'Solicitar revisão',
  open: 'Abrir revisão',
  requested: 'Revisão solicitada',
  requestedDetail: 'A contabilidade recebeu as evidências desta conta.',
  analysis: 'Analisando valores…',
  applying: 'Aplicando atribuição…',
  resuming: 'Verificando aprovação…',
  resolved: 'Revisão concluída',
  partial: 'Atribuição salva. Ainda há valores para revisar.',
  approved: 'Conta aprovada',
  pending: 'Revisão concluída. A conta continua pendente de aprovação.',
  error: 'Não foi possível concluir. Tente novamente.',
  stale: 'As evidências mudaram. Confira os valores atualizados antes de aplicar.',
  invalid: 'Informe tributo, competência, valor válido e motivo para cada atribuição.',
  noEvidence: 'Nenhum movimento sem atribuição.',
  reversalUsesSource: 'Atribua o lançamento original. O estorno acompanha essa atribuição.',
  requiresReconciliation: 'Confira os saldos e corrija as pendências contábeis.',
  openingNeedsEvidence: 'Saldo importado sem lançamento de origem. Revise a importação.',
  preservedHelp:
    'O saldo histórico foi preservado fora das novas contas de tributos. Corrija os lançamentos e as divergências da importação em cada livro; depois verifique novamente. Saldos de livros diferentes não se compensam.',
  preservedPending: 'Corrija as pendências do saldo legado e verifique novamente.',
  preservedBook: 'Livro contábil · {{currency}}',
  preservedOpening: 'Pendências de importação ou saldo: {{count}}.',
  preservedLedger: 'Abrir razão',
  reason: 'Motivo',
  tax: 'Tributo',
  period: 'Competência',
  amount: 'Valor',
  source: 'Lançamento de origem',
  sourceAmount: 'Sem atribuição: {{amount}}',
  sourceUsage: 'Reconhecido: {{recognized}} · vinculado a guias: {{consumed}}',
  sourceHelp:
    'Atribua somente valores comprovados. Créditos e débitos mantêm o sinal do lançamento. O saldo não atribuído continua em revisão.',
  reviewHelp:
    'A atribuição identifica o tributo sem criar outro lançamento. Correções contábeis devem ser feitas em lançamentos manuais.',
  totals: 'Saldos por tributo',
  physicalTotals: 'Total contábil por etapa',
  noTax: 'Manter em revisão',
  confirm: 'Conferir atribuição',
  confirmTitle: 'Confirmar atribuição',
  apply: 'Aplicar atribuição',
  refresh: 'Verificar novamente',
  reload: 'Atualizar evidências',
  correction: 'Abrir lançamentos manuais',
  back: 'Voltar',
  close: 'Fechar',
  cancel: 'Cancelar',
  resume: 'Continuar aprovação',
  readOnly: 'Somente a contabilidade autorizada pode atribuir estes valores.',
  precisionUnavailable: 'A precisão desta moeda não permite edição neste formulário.',
  stage: { APURADO: 'Apurado', EM_GUIAS_A_PAGAR: 'Em Guias a Pagar', LEGADO: 'Legado' },
};

export const taxLiabilityReviewEn = {
  title: 'Review tax liability',
  history: 'Historical amounts need accounting review.',
  request: 'Request review',
  open: 'Open review',
  requested: 'Review requested',
  requestedDetail: 'Accounting has received the evidence for this bill.',
  analysis: 'Analyzing amounts…',
  applying: 'Applying attribution…',
  resuming: 'Checking approval…',
  resolved: 'Review completed',
  partial: 'Attribution saved. Some amounts still need review.',
  approved: 'Bill approved',
  pending: 'Review completed. The bill is still awaiting approval.',
  error: 'Could not complete this action. Try again.',
  stale: 'The evidence changed. Check the updated amounts before applying.',
  invalid: 'Enter a tax, assessment period, valid amount and reason for each attribution.',
  noEvidence: 'No unattributed movements.',
  reversalUsesSource: 'Attribute the original journal. Its reversal follows the same attribution.',
  requiresReconciliation: 'Review the balances and correct the accounting exceptions.',
  openingNeedsEvidence: 'Imported balance without a source journal. Review the import.',
  preservedHelp:
    'The historical balance remains outside the new tax accounts. Correct journal and import discrepancies in each book, then check again. Balances in different books do not offset each other.',
  preservedPending: 'Correct the legacy balance exceptions, then check again.',
  preservedBook: 'Accounting book · {{currency}}',
  preservedOpening: 'Import or balance discrepancies: {{count}}.',
  preservedLedger: 'Open ledger',
  reason: 'Reason',
  tax: 'Tax',
  period: 'Assessment period',
  amount: 'Amount',
  source: 'Source journal',
  sourceAmount: 'Unattributed: {{amount}}',
  sourceUsage: 'Recognized: {{recognized}} · linked to guides: {{consumed}}',
  sourceHelp:
    'Attribute verified amounts only. Credits and debits retain their journal direction. Unattributed balances remain under review.',
  reviewHelp:
    'Attribution identifies the tax without creating another journal. Accounting corrections use manual entries.',
  totals: 'Balances by tax',
  physicalTotals: 'Accounting total by stage',
  noTax: 'Keep under review',
  confirm: 'Review attribution',
  confirmTitle: 'Confirm attribution',
  apply: 'Apply attribution',
  refresh: 'Check again',
  reload: 'Refresh evidence',
  correction: 'Open manual entries',
  back: 'Back',
  close: 'Close',
  cancel: 'Cancel',
  resume: 'Continue approval',
  readOnly: 'Only authorized accountants can attribute these amounts.',
  precisionUnavailable: 'This form cannot edit amounts with this currency precision.',
  stage: { APURADO: 'Assessed', EM_GUIAS_A_PAGAR: 'Guides payable', LEGADO: 'Legacy' },
};
